import React from 'react'
import { useState } from "react";
import { ChevronDown } from "lucide-react";
const Accordian = () => {
    const [isOpen, setIsOpen] = useState(false);
  return (
    
    <div className="flex justify-center items-center mt-3">
    <div className="w-full">
      <div className="bg-gray-900 text-white p-4 rounded-md shadow-md">
        <div
          className="flex justify-between items-center cursor-pointer"
          onClick={() => setIsOpen(!isOpen)}
        >
          <h2 className="font-semibold text-[14px]">
            Online Sports Betting in GUGOBET India
          </h2>
          <ChevronDown
            className={`transform transition-transform duration-300 ${
              isOpen ? "rotate-180" : "rotate-0"
            }`}
          />
        </div>
        {isOpen && (
          <div className="mt-3 text-gray-300 text-sm space-y-2">
            <p>
              Sports betting in India is immensely popular, what if we told you
              that there is a betting platform that provides 40+ sports 100+
              tournaments, including Cricket, Football, Tennis, Basketball,
              Kabaddi, and much more.
            </p>
            <p>
              Numerous betting options up to your decision, including betting
              exchange, live betting, outright betting, and of course{" "}
              <span className="text-blue-400 cursor-pointer">IPL betting online</span>. Gives
              you the best sports betting odds for wagering with exclusive
              bonuses and rewards to multiply your winnings. Offer multiple
              deposit and withdrawal options with 100% authenticity and safety.
              Support 24*7 customer services throughout the year.
            </p>
            <p>
              The probability is that you would not believe us. Still, once you
              have a look at the GUGOBET’s online betting site, you will
              definitely immerse yourself in the best betting experience offered
              by us.
            </p>
            <p>
              If you read till the end of this article, you will have a complete
              idea about GUGOBET, the betting options, and sports betting odds
              provided by the platform to users across the globe. You will also
              get an idea of how crucial GUGOBET is to improving the experience
              of sports betting in India.
            </p>
          </div>
        )}
      </div>
    </div>
  </div>
  )
}

export default Accordian
